import React, {useContext} from 'react';

export const TenancyContext = React.createContext("gastearsivi")

export default function useTenant() {
  const tenant = useContext(TenancyContext)
  return tenant
}
